import React, { createContext, useContext, useMemo } from 'react'

export interface SharedLoanShell {
  success?: boolean
  loanNumber?: number
  displayId?: string
  sourceLoanNumber?: number
  shareIndex?: number
  locked?: boolean
  sharedFeatures?: Record<string, boolean>
  allowedPages?: Record<string, string[]>
  loan?: Record<string, unknown>
  loanProcess?: Record<string, unknown> | null
  readOnly?: boolean
}

export interface SharedLoanContextValue {
  readOnly: true
  peerId: string
  loanNumber: number
  pageKey: string
  pageData: unknown
  reloadPage: () => Promise<void>
  shell: SharedLoanShell
}

const SharedLoanContext = createContext<SharedLoanContextValue | null>(null)

export const useSharedLoan = () => useContext(SharedLoanContext)

export const useIsSharedLoan = () => !!useContext(SharedLoanContext)?.readOnly

interface SharedLoanProviderProps {
  peerId: string
  loanNumber: number
  pageKey: string
  pageData: unknown
  reloadPage: () => Promise<void>
  shell: SharedLoanShell
  children: React.ReactNode
}

export function SharedLoanProvider({
  peerId,
  loanNumber,
  pageKey,
  pageData,
  reloadPage,
  shell,
  children,
}: SharedLoanProviderProps) {
  const value = useMemo<SharedLoanContextValue>(
    () => ({
      readOnly: true,
      peerId,
      loanNumber,
      pageKey,
      pageData,
      reloadPage,
      shell,
    }),
    [peerId, loanNumber, pageKey, pageData, reloadPage, shell],
  )

  return <SharedLoanContext.Provider value={value}>{children}</SharedLoanContext.Provider>
}
